// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import LocaleDropdownController from "./locale_dropdown_controller"
application.register("locale-dropdown", LocaleDropdownController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)
